/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCurrencies = /* GraphQL */ `
  mutation CreateCurrencies($currency: CreateCurrenciesInput!) {
    createCurrencies(currency: $currency) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export const deleteCurrencies = /* GraphQL */ `
  mutation DeleteCurrencies($currencyId: String!) {
    deleteCurrencies(currencyId: $currencyId)
  }
`;
export const updateCurrencies = /* GraphQL */ `
  mutation UpdateCurrencies($currency: UpdateCurrenciesInput!) {
    updateCurrencies(currency: $currency) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export const createAppConfig = /* GraphQL */ `
  mutation CreateAppConfig($appConfig: CreateAppConfigInput!) {
    createAppConfig(appConfig: $appConfig) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      disableApp
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
    }
  }
`;
export const deleteAppConfig = /* GraphQL */ `
  mutation DeleteAppConfig($appConfigId: String!) {
    deleteAppConfig(appConfigId: $appConfigId)
  }
`;
export const updateAppConfig = /* GraphQL */ `
  mutation UpdateAppConfig($appConfig: UpdateAppConfigInput!) {
    updateAppConfig(appConfig: $appConfig) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      disableApp
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
    }
  }
`;
export const createErrorMessages = /* GraphQL */ `
  mutation CreateErrorMessages($errorMessages: CreateErrorMessagesInput!) {
    createErrorMessages(errorMessages: $errorMessages) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export const deleteErrorMessages = /* GraphQL */ `
  mutation DeleteErrorMessages($errorMessagesId: String!) {
    deleteErrorMessages(errorMessagesId: $errorMessagesId)
  }
`;
export const updateErrorMessages = /* GraphQL */ `
  mutation UpdateErrorMessages($errorMessages: UpdateErrorMessagesInput!) {
    updateErrorMessages(errorMessages: $errorMessages) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export const createMessages = /* GraphQL */ `
  mutation CreateMessages($messages: CreateMessagesInput!) {
    createMessages(messages: $messages) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      Marketing
      MatchAll
    }
  }
`;
export const deleteMessages = /* GraphQL */ `
  mutation DeleteMessages($messagesId: String!) {
    deleteMessages(messagesId: $messagesId)
  }
`;
export const updateMessages = /* GraphQL */ `
  mutation UpdateMessages($messages: UpdateMessagesInput!) {
    updateMessages(messages: $messages) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      Marketing
      MatchAll
    }
  }
`;
export const createPolicy = /* GraphQL */ `
  mutation CreatePolicy($policy: CreatePolicyInput!) {
    createPolicy(policy: $policy) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export const deletePolicy = /* GraphQL */ `
  mutation DeletePolicy($policyId: String!) {
    deletePolicy(policyId: $policyId)
  }
`;
export const updatePolicy = /* GraphQL */ `
  mutation UpdatePolicy($policy: UpdatePolicyInput!) {
    updatePolicy(policy: $policy) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export const createPushNotification = /* GraphQL */ `
  mutation CreatePushNotification(
    $pushNotification: CreatePushNotificationInput!
  ) {
    createPushNotification(pushNotification: $pushNotification) {
      pushNotification {
        id
        name
        title
        scheduleId
        body
        deeplink
        dueOn
        throttleRate
        autoPauseSchedule
        pauseSendingTime
        resumeSendingTime
        application
        tmcUsers
        tiUsers
        deviceOS
        status
      }
      scheduleResponse {
        scheduleId
        message
      }
    }
  }
`;
export const deletePushNotification = /* GraphQL */ `
  mutation DeletePushNotification($deleteID: DeletePushNotificationInput!) {
    deletePushNotification(deleteID: $deleteID)
  }
`;
export const updatePushNotification = /* GraphQL */ `
  mutation UpdatePushNotification(
    $pushNotification: UpdatePushNotificationInput!
  ) {
    updatePushNotification(pushNotification: $pushNotification) {
      id
      name
      title
      scheduleId
      body
      deeplink
      dueOn
      throttleRate
      autoPauseSchedule
      pauseSendingTime
      resumeSendingTime
      application
      tmcUsers
      tiUsers
      deviceOS
      status
    }
  }
`;
